(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diisea-register-account"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setError(form, message, field) {
    var box = form.querySelector('[data-dra-form-errors]');
    form.querySelectorAll('[aria-invalid="true"]').forEach(function (input) {
      input.removeAttribute('aria-invalid');
    });
    if (!box) return;
    if (message) {
      box.hidden = false;
      box.textContent = message;
      if (field) {
        field.setAttribute('aria-invalid', 'true');
        if (box.id) field.setAttribute('aria-describedby', box.id);
      }
    } else {
      box.hidden = true;
      box.textContent = '';
    }
  }

  function closestSection(node) {
    return node && node.closest ? node.closest('.shopify-section') : null;
  }

  function isRegisterAccountSection(section) {
    return !!(section && section.querySelector('[data-diisea-register-account]'));
  }

  function looksLikeProductForm(section) {
    if (!section || isRegisterAccountSection(section)) return false;
    var sectionId = section.id || '';
    if (sectionId.indexOf('footer') !== -1 || sectionId.indexOf('header') !== -1) return false;
    if (section.closest('.shopify-section-group-footer-group, .shopify-section-group-header-group')) return false;
    if (section.querySelector('.diisea-register-engage, .diisea-benefits, .diisea-back-support')) return false;
    if (section.querySelector('.shopify-app-block')) return true;
    var frames = section.querySelectorAll('iframe');
    for (var f = 0; f < frames.length; f++) {
      var src = (frames[f].getAttribute('src') || '').toLowerCase();
      if (src.indexOf('form') !== -1 || src.indexOf('shopify') !== -1) return true;
    }
    var forms = section.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].querySelector('[name="customer[password]"]')) continue;
      var action = (forms[i].getAttribute('action') || '').toLowerCase();
      if (action.indexOf('/account') !== -1) continue;
      if (forms[i].querySelector('select') || action.indexOf('form') !== -1 || action.indexOf('contact') !== -1) return true;
    }
    return false;
  }

  function findScrollTarget(targetId, findForms) {
    if (targetId) {
      var byId = document.getElementById(targetId);
      if (byId) return byId;
    }
    if (!findForms) return null;

    var account = document.querySelector('[data-diisea-register-account]');
    var accountSection = closestSection(account);
    if (accountSection) {
      if (looksLikeProductForm(accountSection.previousElementSibling)) return accountSection.previousElementSibling;
      if (looksLikeProductForm(accountSection.nextElementSibling)) return accountSection.nextElementSibling;
    }

    var sections = document.querySelectorAll('.shopify-section');
    for (var s = 0; s < sections.length; s++) {
      if (looksLikeProductForm(sections[s])) return sections[s];
    }
    return null;
  }

  var serverErrors = document.querySelector('.diisea-register-account__errors');
  if (serverErrors) serverErrors.focus();

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-dra-toggle-password]');
    if (toggle) {
      var inputId = toggle.getAttribute('aria-controls');
      var input = inputId ? document.getElementById(inputId) : null;
      if (!input) return;
      var show = input.type === 'password';
      input.type = show ? 'text' : 'password';
      toggle.setAttribute('aria-pressed', show ? 'true' : 'false');
      var confirmToggle = input.hasAttribute('data-dra-password-confirm');
      toggle.setAttribute(
        'aria-label',
        show
          ? confirmToggle
            ? 'Hide confirm password'
            : 'Hide password'
          : confirmToggle
            ? 'Show confirm password'
            : 'Show password'
      );
      toggle.textContent = show ? 'Hide' : 'Show';
      return;
    }

    var scrollBtn = event.target.closest('[data-diisea-register-scroll]');
    if (!scrollBtn) return;
    var targetId = (scrollBtn.getAttribute('data-target') || '').replace(/^#/, '').trim();
    var findForms = scrollBtn.getAttribute('data-find-forms') === 'true';
    var target = findScrollTarget(targetId, findForms);
    if (!target) return;
    event.preventDefault();
    var header = document.querySelector('header');
    var offset = 24;
    if (header) offset += header.getBoundingClientRect().height;
    target.style.scrollMarginTop = offset + 'px';
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.diisea-register-account__form');
    if (!form) return;

    var firstName = form.querySelector('[name="customer[first_name]"]');
    var lastName = form.querySelector('[name="customer[last_name]"]');
    var email = form.querySelector('[name="customer[email]"]');
    var password = form.querySelector('[name="customer[password]"]');
    var confirm = form.querySelector('[data-dra-password-confirm]');
    var terms = form.querySelector('[data-dra-terms]');

    setError(form, '');

    if (!firstName || !firstName.value.trim()) {
      event.preventDefault();
      setError(form, 'Please enter your first name.', firstName);
      if (firstName) firstName.focus();
      return;
    }
    if (!lastName || !lastName.value.trim()) {
      event.preventDefault();
      setError(form, 'Please enter your last name.', lastName);
      if (lastName) lastName.focus();
      return;
    }
    if (!email || !email.value.trim() || !email.checkValidity()) {
      event.preventDefault();
      setError(form, 'Please enter a valid email address.', email);
      if (email) email.focus();
      return;
    }
    if (!password || !password.value) {
      event.preventDefault();
      setError(form, 'Please enter a password.', password);
      if (password) password.focus();
      return;
    }
    if (!confirm || confirm.value !== password.value) {
      event.preventDefault();
      setError(form, 'Passwords do not match.', confirm);
      if (confirm) confirm.focus();
      return;
    }
    if (!terms || !terms.checked) {
      event.preventDefault();
      setError(form, 'Please agree to the Terms of Service and Privacy Policy.', terms);
      if (terms) terms.focus();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diisea-support-manuals"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('diisea-support-manuals')) {
  class DiiseaSupportManuals extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abortController = new AbortController();
      var signal = this.abortController.signal;

      this.groups = Array.prototype.slice.call(
        this.querySelectorAll('.diisea-support-manuals__group[data-category-key]')
      );
      this.empty = this.querySelector('[data-dsm-empty]');

      this.onCategoryChange = this.onCategoryChange.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      document.addEventListener('diisea:support-category-change', this.onCategoryChange, { signal: signal });
      document.addEventListener('shopify:block:select', this.onBlockSelect, { signal: signal });

      this.applyCategory(this.resolveInitialKey(), { dispatch: false });
    }

    disconnectedCallback() {
      this.initialized = false;
      if (this.abortController) this.abortController.abort();
    }

    uniqueCategoryKeys() {
      var keys = [];
      this.groups.forEach(function (group) {
        var key = group.getAttribute('data-category-key') || '';
        if (key && keys.indexOf(key) === -1) keys.push(key);
      });
      return keys;
    }

    resolveInitialKey() {
      var fromPage = (document.documentElement.dataset.diiseaSupportCategory || '').trim();
      if (fromPage) return fromPage;
      var defaultKey = (this.dataset.defaultKey || '').trim();
      if (defaultKey) return defaultKey;
      var keys = this.uniqueCategoryKeys();
      return keys[0] || '';
    }

    onCategoryChange(event) {
      var detail = event.detail || {};
      if (detail.source === 'manuals') return;
      if (!detail.key) return;
      this.applyCategory(detail.key, { dispatch: false });
    }

    onBlockSelect(event) {
      if (!event.target || !event.target.contains(this)) return;
      var blockId = event.detail && event.detail.blockId;
      if (!blockId) return;
      var node = this.querySelector('[data-block-id="' + blockId + '"]');
      if (!node) return;
      var key = node.getAttribute('data-category-key');
      if (!key) return;
      this.applyCategory(key, { dispatch: true, source: 'manuals' });
    }

    applyCategory(key, options) {
      var settings = options || {};
      var visible = 0;

      this.groups.forEach(function (group) {
        var match = group.getAttribute('data-category-key') === key;
        if (match) {
          group.hidden = false;
          group.removeAttribute('hidden');
          visible += 1;
        } else {
          group.hidden = true;
          group.setAttribute('hidden', '');
        }
      });

      if (this.empty) {
        if (visible === 0) {
          this.empty.hidden = false;
          this.empty.removeAttribute('hidden');
        } else {
          this.empty.hidden = true;
          this.empty.setAttribute('hidden', '');
        }
      }

      if (settings.dispatch && key) {
        document.documentElement.dataset.diiseaSupportCategory = key;
        document.dispatchEvent(
          new CustomEvent('diisea:support-category-change', {
            detail: {
              key: key,
              title: '',
              source: settings.source || 'manuals'
            }
          })
        );
      }
    }
  }

  customElements.define('diisea-support-manuals', DiiseaSupportManuals);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diisea-support-product-categories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('diisea-support-categories')) {
  class DiiseaSupportCategories extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abortController = new AbortController();
      var signal = this.abortController.signal;

      this.track = this.querySelector('[data-dsc-track]');
      this.prev = this.querySelector('[data-dsc-prev]');
      this.next = this.querySelector('[data-dsc-next]');
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-category-key]'));

      this.onItemClick = this.onItemClick.bind(this);
      this.onExternalChange = this.onExternalChange.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);

      this.addEventListener('click', this.onItemClick, { signal: signal });
      document.addEventListener('diisea:support-category-change', this.onExternalChange, { signal: signal });
      document.addEventListener('shopify:block:select', this.onBlockSelect, { signal: signal });

      if (this.track) {
        this.track.addEventListener('scroll', this.onScroll, { signal: signal, passive: true });
        if (typeof ResizeObserver === 'function') {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.track);
        }
        window.addEventListener('resize', this.onScroll, { signal: signal });
      }

      if (this.prev) this.prev.addEventListener('click', this.onPrev, { signal: signal });
      if (this.next) this.next.addEventListener('click', this.onNext, { signal: signal });

      this.activate(this.resolveInitialKey(), { dispatch: true, source: 'categories', scroll: false });
      this.updateArrows();
    }

    disconnectedCallback() {
      this.initialized = false;
      if (this.abortController) this.abortController.abort();
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    resolveInitialKey() {
      var defaultKey = (this.dataset.defaultKey || '').trim();
      var keys = this.items.map(function (item) {
        return item.getAttribute('data-category-key') || '';
      });
      if (defaultKey && keys.indexOf(defaultKey) !== -1) return defaultKey;
      return keys[0] || '';
    }

    onItemClick(event) {
      var button = event.target.closest('[data-category-key]');
      if (!button || !this.contains(button)) return;
      this.activate(button.getAttribute('data-category-key'), {
        dispatch: true,
        source: 'categories'
      });
    }

    onExternalChange(event) {
      var detail = event.detail || {};
      if (detail.source === 'categories') return;
      if (!detail.key) return;
      this.activate(detail.key, { dispatch: false });
    }

    onBlockSelect(event) {
      if (!event.target || !event.target.contains(this)) return;
      var blockId = event.detail && event.detail.blockId;
      if (!blockId) return;
      var item = this.querySelector('[data-block-id="' + blockId + '"]');
      if (!item) return;
      this.activate(item.getAttribute('data-category-key'), {
        dispatch: true,
        source: 'categories'
      });
    }

    onScroll() {
      this.updateArrows();
    }

    onPrev(event) {
      event.preventDefault();
      this.scrollTrack(-1);
    }

    onNext(event) {
      event.preventDefault();
      this.scrollTrack(1);
    }

    activate(key, options) {
      if (!key) return;
      var settings = options || {};
      var matched = false;
      var activeItem = null;

      this.items.forEach(function (item) {
        var on = item.getAttribute('data-category-key') === key;
        item.classList.toggle('is-active', on);
        item.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) {
          matched = true;
          activeItem = item;
        }
      });

      if (!matched) return;

      document.documentElement.dataset.diiseaSupportCategory = key;

      if (settings.dispatch) {
        document.dispatchEvent(
          new CustomEvent('diisea:support-category-change', {
            detail: {
              key: key,
              title: activeItem ? activeItem.getAttribute('data-category-title') || '' : '',
              source: settings.source || 'categories'
            }
          })
        );
      }

      if (settings.scroll !== false) {
        this.scrollItemIntoView(activeItem);
      }
    }

    scrollItemIntoView(item) {
      if (!item || !this.track) return;
      this.updateArrows();
      if (!this.classList.contains('is-overflow')) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var itemRect = item.getBoundingClientRect();
      var trackRect = this.track.getBoundingClientRect();
      var left = this.track.scrollLeft + (itemRect.left - trackRect.left) - (trackRect.width - itemRect.width) / 2;
      this.track.scrollTo({
        left: Math.max(0, left),
        behavior: reduce ? 'auto' : 'smooth'
      });
    }

    scrollTrack(direction) {
      if (!this.track) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var distance = Math.max(this.track.clientWidth * 0.72, 200);
      this.track.scrollBy({
        left: distance * direction,
        behavior: reduce ? 'auto' : 'smooth'
      });
    }

    updateArrows() {
      if (!this.track) return;
      var maxScroll = this.track.scrollWidth - this.track.clientWidth;
      var overflow = maxScroll > 2;
      this.classList.toggle('is-overflow', overflow);

      if (this.prev) {
        this.prev.hidden = !overflow;
        this.prev.disabled = !overflow || this.track.scrollLeft <= 2;
      }
      if (this.next) {
        this.next.hidden = !overflow;
        this.next.disabled = !overflow || this.track.scrollLeft >= maxScroll - 2;
      }
    }
  }

  customElements.define('diisea-support-categories', DiiseaSupportCategories);
}

  } catch(e) { console.error(e); }
})();
})();
